import { weekDayNameToWeekDayNumber } from '@/resources/utils/global/dates'
import type { SellerInfo } from '@/resources/types/seller'

export function getPocSundayEnabledFromSellerInfo(
  seller: SellerInfo | undefined
): boolean {
  const workDays = seller?.shop?.workDays
  return (
    workDays?.find(day => day.weekDay === weekDayNameToWeekDayNumber.sunday)
      ?.enabled ?? false
  )
}
